import { get } from 'svelte/store';
import { rateService } from 'src/services/http';
import { home_data } from 'src/stores/account/user';
import { os } from 'src/stores/session/native-bridge';

export const ratingPromptHelper = async () => {
	let platform = get(os) == 'IOS' ? 'ios' : 'android';
	let ratingPromptState = false;

	const response = await rateService.get('');

	if (!response || ('isok' in response && !response.isok) || 'errors' in response) {
		console.error('Error fetching rating data', response);
		return;
	}

	if (get(home_data)?.shouldShowRateUs) {
		if (
			typeof response[platform] == 'undefined' ||
			(response[platform]?.show && response[platform]?.userAction !== 'later') ||
			(response[platform]?.show &&
				response[platform]?.userAction === 'later' &&
				response[platform]?.ts < Date.now() - 1000 * 60 * 60 * 24 * 2)
		) {
			ratingPromptState = true;
		}
	}

	return ratingPromptState;
};
